import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="w-screen flex justify-center py-16 md:py-32 bg-[#F7F7F7] border-t border-gray-200 relative z-40 overflow-x-hidden">
      <div className="w-full max-w-[1280px] px-4 md:px-8">
        <div className="flex flex-col gap-12 md:gap-16">
          {/* Logo and Mission */}
          <div className="flex flex-col gap-6 md:gap-8">
            <img 
              src="/images/logo/lagaviota-logo.png" 
              alt="La Gaviota" 
              className="h-8 md:h-10 w-auto object-contain"
            />
            <h2 className="headline-small md:headline-medium max-w-[580px]">
              Brindamos educación preescolar y rehabilitación a niños y niñas, con y sin discapacidad neuromotora.
            </h2>
          </div>

          {/* Social Links */}
          <div className="flex flex-col gap-6 md:gap-8">
            <h3 className="body-medium text-black/50">Síguenos</h3>
            {/* Responsive grid layout for social links */}
            <div className="flex flex-col md:flex-row md:justify-start items-start gap-0 md:gap-6 max-w-2xl">
              <Link 
                to="https://www.instagram.com/lagaviotaiap/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-black hover:text-black/70 transition-colors body-small md:body text-center md:text-left p-2 md:p-0"
              >
                Instagram
              </Link>
              <Link 
                to="https://www.facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-black hover:text-black/70 transition-colors body-small md:body text-center md:text-left p-2 md:p-0"
              >
                Facebook
              </Link>
              <Link 
                to="https://www.instagram.com/rumore.digital/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-black hover:text-black/70 transition-colors body-small md:body text-center md:text-left p-2 md:p-0"
              >
                Rumore
              </Link>
              <Link 
                to="https://x.com/Lgaviota" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-black hover:text-black/70 transition-colors body-small md:body text-center md:text-left p-2 md:p-0"
              >
                X
              </Link>
              <Link 
                to="https://www.linkedin.com/company/la-gaviota-iap/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-black hover:text-black/70 transition-colors body-small md:body text-center md:text-left p-2 md:p-0 col-span-2 md:col-span-1"
              >
                LinkedIn
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
} 